



























import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from './components/HelloWorld.vue';
import Header from './atomic/organisms/Header.vue';
import InfoBoxesList from './atomic/organisms/InfoBoxesList.vue';
import SettingsSidebar from './atomic/organisms/SettingsSidebar.vue';
import AsideNavigation from './atomic/organisms/AsideNavigation.vue';

import site from '@/store/modules/site';

@Component({
  components: {
    HelloWorld,
    Header,
    InfoBoxesList,
    SettingsSidebar,
    AsideNavigation,
  },
})
export default class App extends Vue {
  get isSidebarNavigationCollapsed(): boolean {
    console.log(this); // eslint-disable-line no-console
    return site.isSidebarNavigationCollapsed;
  }

  get isSidebarOptionsCollapsed(): boolean {
    console.log(this); // eslint-disable-line no-console
    return site.isSidebarOptionsCollapsed;
  }
}
